import _ from "lodash";
import * as z from "../../../framework";
import { toolTip } from "../../controls/toolTip";
import { ll } from "../../core/ll";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_Input from "../templates/K_Input";
import { InputOptions } from "./input";
import { TemplateComponent } from "./templateComponent";

export interface DidYouMeanTextBoxOptions extends InputOptions {
    bindNumberValue?: string;
    inputType?: "password";
    min?: number;
    useLink?: boolean | "true";
    linkedTo?: string;
    linkedToBind?: string;
    linkedClasses?: string;
    maxLength?: number | string;
    searchType?: string | any;
    readOnly?: boolean;
    showIcon?: boolean;
    labelField?: string;
    bindClass?: string;
    valueField?: string;
    bindId?: string;
    bindObject?: string;
    placeholder?: string;
    width?: number;
    containsSearch?: boolean | "true";
    Required?: boolean | "true";
    decimals?: number;
    format?: string;
    entity: string;
    searchField: string;
    urlField: string;
    header: string;
}

export class DidYouMeanTextBox extends TemplateComponent {
    options: DidYouMeanTextBoxOptions;
    correlationGroupId: string;

    constructor(options: DidYouMeanTextBoxOptions) {
        super(K_Input, options);
    }

    preRender() {
        const me = this,
            options = me.options;

        me.correlationGroupId = kendo.guid();

        // Set defaults for woop fields
        if (options.labelAbove) {
            options.bsc = options.bsc || " ";
            if (options.valueWidth) {
                options.containerWidth = options.containerWidth || +options.valueWidth + 10;
                options.labelWidth = options.labelWidth || options.valueWidth;
            }
            options.labelAbove = buildDataBindSyntax(options.labelAbove, "text");
        }

        options.label = buildDataBindSyntax(options.label, "text");
        options.bindNumberValue = buildDataBindSyntax(options.bindNumberValue, "text");
        options.bindValue = buildDataBindSyntax(options.bindValue, "input");
        options.containerClasses = options.containerClasses || "";
        options.containerBind = buildDataBindSyntax(options.containerBind, "container");
        options.bsc = options.bsc || "col-lg-3 col-md-4 col-xs-6";
        options.labelBsc = options.labelBsc || "col-xs-5";
        options.inputBsc = options.inputBsc || "col-xs-7  no-pad";
        options.useLink = options.useLink || null;
        options.linkedTo = options.linkedTo || null;
        options.linkedToBind = options.linkedToBind || null;

        if (this.id.toString().indexOf("_UDF_") != -1) {
            options.maxLength = 500;
        }

        $(".didYouMeanListBox").remove();
    }

    create() {
        const me = this;

        if (me.options.infoTooltip) {
            toolTip({
                alignX: "center",
                alignY: "top",
                alignTo: "target",
                offsetY: 5,
                selector: $(`#${this.id}_info`),
                content: ll(this.options.infoTooltip)
            });
        }

        let component = this,
            textBox = $(`#${me.id}`);

        if ((component.options.readonly || component.options.readOnly)
            && textBox
        ) {
            textBox.readOnly(true);
        }

        if (component.options.useLink
            && component.options.linkedTo
            && component.options.linkedToBind
        ) {
            let sourceControl = $(`#${component.options.zScreen.id}_${component.options.linkedTo}`),
                linkControl = $(`#${component.id}_linked`);

            linkControl.tie("change", function () {
                let linked = $(me).prop("checked"),
                    parentComponent = $(`#${component.id}`);

                if (linked) {
                    parentComponent.readOnly(true);
                    linkControl.prop("required", true);

                    sourceControl.tie("change.linkedControl", function () {
                        parentComponent.val(sourceControl.val());
                        parentComponent.change();
                    });

                    sourceControl.change();
                } else {
                    parentComponent.readOnly(false);
                    linkControl.prop("required", false);
                    sourceControl.off("change.linkedControl");
                }
            });

            linkControl.data("parentComponent", component);
        }

        let valueCaught = "";
        textBox.on("change", function (event) {
            valueCaught = textBox.val();

            if (valueCaught.trim().length == 0) {
                textBox.val("");
            }
        });

        textBox.on("change, keyup", _.debounce((e) => {
            const entity = me.options.entity,
                searchField = me.options.searchField,
                urlField = me.options.urlField,
                minCharLength = 3;

            let searchTerm = textBox.val() || "";
            searchTerm = searchTerm.trim();

            if (!entity
                || !searchField
                || !urlField
                || !searchTerm
                || searchTerm.length < minCharLength
            ) {
                $(".didYouMeanListBox").remove();
                return;
            }

            const odataFilter = z.filter.contains(searchField, searchTerm).toString();
            z.ajax({
                url: `${entity}?$top=5&$filter=${odataFilter}&$select=${searchField},${urlField}`,
                correlationGroupId: me.correlationGroupId
            }).done(function (response) {
                const data = response.d.results;
                if (data.length == 0) {
                    $(".didYouMeanListBox").remove();
                    return;
                }

                if (!urlField || urlField.length < 2) {
                    return;
                }

                const urlParam = urlField[0].toLowerCase() + urlField.substring(1),
                    listItemHtml = _.map(data, function (record) {
                        const searchFieldValue = record[searchField];

                        return searchFieldValue
                            ? `
                                <a href="/${entity}/?${urlParam}=${record[urlField]}" target="_blank">
                                    <div class="dup">
                                        <span>${searchFieldValue}</span>
                                    </div>
                                </a>`
                            : true;
                }).join("");

                const header = z.ll(me.options.header),
                    width = me.options.width
                        ? `${me.options.width}px`
                        : "100%";

                $(".didYouMeanListBox").remove();
                textBox.parent().append(`
                    <div class="didYouMeanListBox" style="width: ${width};">
                        <div class="prompt">${header}</div>
                        <div class="dup-list">${listItemHtml}</div>
                    </div>`);
            });
        }, 500));
    }
}
